import { Region } from "./enums";

export interface RegionConfig {
	id?: number;
	region: Region;
	is_mwst_eust: boolean;
	mwst_number: string | null;
	mwst_percentage: number | null;
	currency_text: string | null;
	round_to: number | null;
}

/**
 * Region metadata for UI display
 */
export interface RegionMetadata {
	value: Region;
	label: string;
	defaultVat: number;
	vatNumberFormat?: string;
	currencyText: string;
	roundTo: number;
}

enum RoundToType {
	TO_INTEGER = 0,
	TO_FIRST_DECIMAL = 1,
	TO_SECOND_DECIMAL = 2,
	TO_THIRD_DECIMAL = 3,
	TO_RAPPEN = 4,
}

export const REGION_METADATA: Record<Region, RegionMetadata> = {
	[Region.CH]: {
		value: Region.CH,
		label: "Schweiz",
		defaultVat: 8.1,
		vatNumberFormat: "CHE-123.456.789 MWST",
		currencyText: "CHF",
		roundTo: RoundToType.TO_RAPPEN,
	},
	[Region.DE]: {
		value: Region.DE,
		label: "Deutschland",
		defaultVat: 19,
		vatNumberFormat: "DE123456789",
		currencyText: "€",
		roundTo: RoundToType.TO_SECOND_DECIMAL,
	},
};

export const LIECHTENSTEIN_VAT_NUMBER_FORMAT = "12345";

/**
 * Get all available regions as an array
 */
export const REGION_OPTIONS: RegionMetadata[] = Object.values(REGION_METADATA);


/**
 * Rounding options for regions
 */
export const ROUND_TO_OPTIONS = [
	{ value: RoundToType.TO_INTEGER, label: "Auf Ganzzahl runden" },
	{ value: RoundToType.TO_FIRST_DECIMAL, label: "Auf 1 Dezimalstelle" },
	{ value: RoundToType.TO_SECOND_DECIMAL, label: "Auf 2 Dezimalstellen" },
	{ value: RoundToType.TO_THIRD_DECIMAL, label: "Auf 3 Dezimalstellen" },
	{ value: RoundToType.TO_RAPPEN, label: "Auf Rappen (0.05)" },
];